module.exports = __webpack_public_path__ + "static/media/twitter.ec1b6394.svg";